module.exports = __webpack_public_path__ + "static/img/merchant_feature_10.b44b032.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/merchant_feature_10.png
// module id = Xn/G
// module chunks = 8